/**
 * Conversão de data entre o datepicker, a URL e a API — uma implementação só
 * para os três níveis de "SMS via Integração".
 *
 * Existia em três lugares: o nível 3 lia componentes locais (correto) e os
 * níveis 1 e 2 usavam `toISOString()`. São coisas diferentes: o datepicker
 * devolve MEIA-NOITE LOCAL, e converter para UTC empurra a data para o dia
 * anterior em qualquer fuso a leste de Greenwich. Três cópias divergentes da
 * mesma regra é como a borda do período volta a quebrar em uma tela só.
 */

/** Date → 'YYYY-MM-DD' (o formato que o backend espera), em horário LOCAL. */
export function formatDateParam(date: Date): string | null {
  if (!date) {
    return null;
  }

  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * 'YYYY-MM-DD' → Date, para o datepicker voltar preenchido quando a tela é
 * aberta por um link já filtrado.
 *
 * O 'T00:00:00' é obrigatório: sem ele o JS interpreta a data como UTC, e no
 * horário de Brasília o componente exibiria o DIA ANTERIOR ao que está na URL.
 */
export function parseDateParam(value: string): Date | null {
  return value ? new Date(`${value}T00:00:00`) : null;
}

/**
 * Data inicial depois da final — não há período nenhum para buscar.
 *
 * Mora aqui pelo mesmo motivo das duas funções acima: os três níveis de "SMS via
 * Integração" filtram pelo mesmo par de datas, e a regra estava escrita em uma
 * tela só. Sem a guarda, o intervalo invertido não é barrado, a busca sai, o
 * backend devolve vazio — e o operador lê "não há envios" em vez de "seu filtro
 * está invertido".
 *
 * Só vale com AS DUAS preenchidas: um período aberto de um lado é filtro
 * legítimo, não erro.
 */
export function isInvalidPeriod(started: Date | null, ended: Date | null): boolean {
  return !!started && !!ended && started > ended;
}
